import React from 'react';
import { FaMountain } from 'react-icons/fa';

const Navbar = () => (
    <nav className="navbar">
        <div className="container">
            <div className="logo">
                <FaMountain className="logo-icon" />
                <h1>Tiwari Minerals Company</h1>
            </div>
            <ul className="nav-links">
                <li><a href="#about">About</a></li>
                <li><a href="#products">Products</a></li>
                <li><a href="#why-us">Why Us</a></li>
                <li><a href="#contact">Contact</a></li>
            </ul>
        </div>
    </nav>
);

export default Navbar;